import { apiBase as apiBaseDefault } from '../project.config.json'

export { appName, locale as defaultLocale, socialLogins } from '../project.config.json'

const {
  BASE_URL,
  NODE_ENV,
  VUE_APP_API_BASE,
  VUE_APP_API_ORIGIN,
  VUE_APP_BUGSNAG_API_KEY,
  VUE_APP_COMMIT_SHA,
  VUE_APP_FB_ID,
  VUE_APP_GA_ID,
  VUE_APP_IS_DEPLOYED,
  VUE_APP_RECAPTCHA_KEY,
  VUE_APP_WEB_URL,
} = process.env

const clientOrigin = window.location.origin

export const basePath = (BASE_URL || '').slice(0, -1)

const clientUrl = `${clientOrigin}${basePath}`

export const webUrl = typeof VUE_APP_WEB_URL !== 'undefined'
  ? VUE_APP_WEB_URL
  : clientUrl

export const webOrigin = webUrl.replace(basePath, '')

export const isDeployedProduction = VUE_APP_IS_DEPLOYED === 'true'

export const isProduction = isDeployedProduction || NODE_ENV === 'production'

export const apiBase = VUE_APP_API_BASE || apiBaseDefault

export const apiOrigin = VUE_APP_API_ORIGIN || clientOrigin

export const apiUrl = `${apiOrigin}${apiBase}`

export const jwtName = 'amjwt'

export const bugsnagApiKey = VUE_APP_BUGSNAG_API_KEY

export const googleAnalyticsId = VUE_APP_GA_ID

export const facebookPixelId = VUE_APP_FB_ID

export const recaptchaKey = VUE_APP_RECAPTCHA_KEY

export const hasSockets = true

export const titleSeparator = '-'

export const commitSha = VUE_APP_COMMIT_SHA

export const doRouteAuth = false
